// extracted by mini-css-extract-plugin
export var capitalize = "TagsListSection-module--capitalize--39adc";
export var fs14 = "TagsListSection-module--fs-14--892c9";
export var fs16 = "TagsListSection-module--fs-16--644ad";
export var fs20 = "TagsListSection-module--fs-20--498d1";
export var fs24 = "TagsListSection-module--fs-24--81638";
export var fs32 = "TagsListSection-module--fs-32--5e106";
export var fs40 = "TagsListSection-module--fs-40--13270";
export var fsItalic = "TagsListSection-module--fs-italic--fc118";
export var fsLg = "TagsListSection-module--fs-lg--9739b";
export var fsMd = "TagsListSection-module--fs-md--72356";
export var fsNormal = "TagsListSection-module--fs-normal--61f08";
export var fsSm = "TagsListSection-module--fs-sm--126d9";
export var fsXl = "TagsListSection-module--fs-xl--9cbc1";
export var fsXs = "TagsListSection-module--fs-xs--c4270";
export var fsXxl = "TagsListSection-module--fs-xxl--6fb24";
export var fsXxs = "TagsListSection-module--fs-xxs--5f239";
export var fwBold = "TagsListSection-module--fw-bold--633ca";
export var fwMedium = "TagsListSection-module--fw-medium--ab8ba";
export var fwNormal = "TagsListSection-module--fw-normal--4d4c0";
export var gotham_bold = "TagsListSection-module--gotham_bold--f109c";
export var gotham_bold_italic = "TagsListSection-module--gotham_bold_italic--dfd4c";
export var gotham_book = "TagsListSection-module--gotham_book--02980";
export var gotham_book_italic = "TagsListSection-module--gotham_book_italic--49802";
export var lowercase = "TagsListSection-module--lowercase--34d27";
export var tagList = "TagsListSection-module--tagList--6ab03";
export var tags = "TagsListSection-module--tags--d80db";
export var uppercase = "TagsListSection-module--uppercase--1f382";